import SimpleDialog from '@rio-cloud/rio-uikit/SimpleDialog';
import { ApiReferenceTable } from './ApiReferenceTable';

export const ApiReferenceDialog = ({ show, onClose }: { show: boolean; onClose: () => void }) => (
    <SimpleDialog show={show} title={'API Reference'} content={<ApiReferenceTable />} onClose={onClose} />
);
